import { combineReducers } from "redux";
import libroReservaReducer from "./libroReservaReducer";
import reservaReducer from "./reservaReducer";
export default combineReducers({
  reserva: reservaReducer,
  libroReserva: libroReservaReducer,
});
